import { Component, Input, OnInit } from '@angular/core';
import { MBTI } from 'src/app/interfaces/mbti';

@Component({
  selector: 'app-survey-profile',
  templateUrl: './survey-profile.component.html',
  styleUrls: ['./survey-profile.component.scss'],
})
export class SurveyProfileComponent implements OnInit {

  constructor() { }

  @Input() name = '';
  @Input() mbtiType: MBTI | undefined;
  @Input() createdAt = '';
  @Input() isWriter = false; // 댓글 작성자 여부
  @Input() isBest = false;

  // 24시간 전에 생성된 댓글 여부
  get isCreated24HoursAgo(): boolean {
    if (this.createdAt) {
      const createdTime = new Date(this.createdAt).getTime();
      const currentTime = new Date().getTime();
      const diffSeconds = (currentTime - createdTime) / 1000;
      return diffSeconds >= (24 * 60 * 60);
    }

    // default: true
    return true;
  }

  ngOnInit() {
  }
}
